import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as yup from "yup";
import Form from "react-bootstrap/Form";
import Button from "@mui/material/Button";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { ModalAllder } from "layouts/ModalAllder";
import { userAdminHandler } from "../../../../redux/handlers";

export function ChangeEmailModal({
  modal,
  setModal,
  setModalEmailSuccess,
  formaccount,
  adminID,
  refreshData,
}) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    empEmail: "",
  });

  const schema = yup.object().shape({
    empEmail: yup
      .string()
      .email("รูปแบบอีเมลไม่ถูกต้อง")
      .required("กรุณากรอกอีเมล"),
  });

  useEffect(() => {
    setForm({
      empEmail: formaccount.empEmail,
    });
  }, [formaccount]);

  const handleSubmit = async (values) => {
    try {
      await dispatch(
        userAdminHandler.updateUserAdminEmail(adminID, values.empEmail)
      );

      await refreshData();

      setModal((prev) => ({ ...prev, open: false }));
      setModalEmailSuccess((prev) => ({ ...prev, open: true }));
    } catch (error) {
      console.error("Error updating email:", error);
    }
  };

  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle={"เปลี่ยนอีเมล"}
      hbtn={true}
    >
      <div className="py-3">
        <div className="">
          <Formik
            enableReinitialize
            initialValues={form}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, handleChange, touched, errors, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="text-center text-xl font-semibold text-[#4C4E64]/[0.87] mb-5">
                  กรุณาระบุอีเมลที่ต้องการเปลี่ยน
                </div>
                <Form.Group className="mb-3 form-st-3 pb-1">
                  <Form.Label className="mb-1">
                    อีเมล <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="empEmail"
                    className="form-control"
                    placeholder="อีเมล"
                    value={values.empEmail}
                    onChange={handleChange}
                    isInvalid={touched.empEmail && !!errors.empEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.empEmail}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="text-center pt-4 pb-3 btn-group-control">
                  <Button
                    size="large"
                    type="button"
                    className="btn-st-6 me-3 !border-[#6D788D] !rounded-lg !text-[#6D788D]"
                    style={{ width: "100px" }}
                    variant={"outlined"}
                    onClick={() =>
                      setModal((prev) => ({ ...prev, open: false }))
                    }
                  >
                    ยกเลิก
                  </Button>
                  <Button
                    size="large"
                    type="submit"
                    variant={"contained"}
                    className="btn-st-3 !rounded-lg"
                    style={{ width: "100px" }}
                  >
                    ยืนยัน
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </ModalAllder>
  );
}

export function ResetpasswordModal({
  modal,
  setModal,
  setModalResetPasswordSuccess,
  adminID,
  refreshData,
}) {
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const schema = yup.object().shape({
    password: yup
      .string()
      .required("กรุณากรอกรหัสผ่าน")
      .min(8, "รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร"),
    confirmPassword: yup
      .string()
      .required("กรุณายืนยันรหัสผ่าน")
      .oneOf([yup.ref("password")], "รหัสผ่านไม่ตรงกัน"),
  });

  const handleSubmit = async (values) => {
    try {
      await dispatch(
        userAdminHandler.updateUserAdminPassword(adminID, values.password)
      );

      await refreshData();

      setModal((prev) => ({ ...prev, open: false }));
      setModalResetPasswordSuccess((prev) => ({
        ...prev,
        open: true,
      }));
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };

  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle={"รีเซ็ตรหัสผ่าน"}
      hbtn={true}
    >
      <div className="py-4">
        <div className="">
          <Formik
            enableReinitialize
            initialValues={form}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, handleChange, touched, errors, values }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <div className="text-center text-xl font-semibold text-[#4C4E64]/[0.87] mb-4">
                  กรุณากรอกรหัสผ่านใหม่
                </div>

                <Form.Group className="mb-3 form-st-3">
                  <Form.Label className="mb-1">
                    รหัสผ่านใหม่ <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder="รหัสผ่านใหม่"
                    value={values.password}
                    onChange={handleChange}
                    isInvalid={touched.password && !!errors.password}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3 form-st-3">
                  <Form.Label className="mb-1">
                    ยืนยันรหัสผ่านใหม่ <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="password"
                    name="confirmPassword"
                    placeholder="ยืนยันรหัสผ่านใหม่"
                    value={values.confirmPassword}
                    onChange={handleChange}
                    isInvalid={
                      touched.confirmPassword && !!errors.confirmPassword
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="text-center pt-4 pb-3 btn-group-control">
                  <Button
                    size="large"
                    type="button"
                    className="btn-st-6 me-3 !border-[#6D788D] !rounded-lg !text-[#6D788D]"
                    style={{ width: "100px" }}
                    variant={"outlined"}
                    onClick={() =>
                      setModal((prev) => ({ ...prev, open: false }))
                    }
                  >
                    ยกเลิก
                  </Button>
                  <Button
                    size="large"
                    type="submit"
                    variant={"contained"}
                    className="btn-st-3 !rounded-lg"
                    style={{ width: "100px" }}
                  >
                    ยืนยัน
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </ModalAllder>
  );
}

export function ChangeEmailSuccessModal({ modal, setModal }) {
  return (
    <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
      <div className="py-4">
        <div className="text-center mb-4">
          <CheckCircleRoundedIcon className="!text-[100px] text-[#2DC76D]" />
        </div>
        <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
          เปลี่ยนอีเมลสำเร็จ
        </div>
      </div>
    </ModalAllder>
  );
}

export function ResetpasswordSuccessModal({ modal, setModal }) {
  return (
    <ModalAllder modal={modal} setModal={setModal} htitle={""} hbtn={false}>
      <div className="py-4">
        <div className="text-center mb-4">
          <CheckCircleRoundedIcon className="!text-[100px] text-[#2DC76D]" />
        </div>
        <div className="text-center text-2xl lh-base font-semibold text-[#4C4E64]/[0.87] mb-4">
          เปลี่ยนรหัสผ่านสำเร็จ
        </div>
      </div>
    </ModalAllder>
  );
}
